import fs from 'node:fs'
import path from 'node:path'

export function readLinkedProjectJson(cwd: string): { projectId?: string } | undefined {
  try {
    const projectJsonPath = path.join(cwd, '.vercel', 'project.json')
    if (!fs.existsSync(projectJsonPath)) return undefined
    return JSON.parse(fs.readFileSync(projectJsonPath, 'utf-8')) as { projectId?: string }
  } catch {
    return undefined
  }
}
